import { PersonalDashboardRoutes } from "src/routes/personal-dashboard/enums";
import { defineRoute } from "src/routing/defineRoute";

/**
 * Path + typed URL builder pairs for migrated Personal Dashboard URLs.
 *
 * Kept separate from `personalDashboard.tsx` (the `RouteObject` tree) so `RouteUrls.ts` and pages can
 * import paths without creating a cycle through page `Component` imports.
 *
 * Nested routes compose from their parent's `.path` so the hierarchy stays visible and absolute
 * strings stay in sync (RR6 requires a child's path to start with its parent's).
 */
export const personalDashboardRoute = defineRoute("/personal-dashboard");
export const personalDashboardActionsRoute = defineRoute(
  `${personalDashboardRoute.path}/${PersonalDashboardRoutes.ACTIONS}`,
);
export const personalDashboardUpcomingRoute = defineRoute(
  `${personalDashboardRoute.path}/${PersonalDashboardRoutes.UPCOMING}`,
);
export const personalDashboardToDosRoute = defineRoute(
  `${personalDashboardRoute.path}/${PersonalDashboardRoutes.TO_DOS}`,
);
export const personalDashboardToDoModalRoute = defineRoute(`${personalDashboardToDosRoute.path}/:toDoId`);
export const personalDashboardApprovalsRoute = defineRoute(
  `${personalDashboardRoute.path}/${PersonalDashboardRoutes.APPROVALS}`,
);
export const personalDashboardActivityRoute = defineRoute(
  `${personalDashboardRoute.path}/${PersonalDashboardRoutes.ACTIVITY}`,
);

/** Compatibility bag matching the legacy `routesDef.personalDashboardPaths` export. */
export const personalDashboardPaths = {
  base: personalDashboardRoute.path,
  dashboard: `${personalDashboardRoute.path}/:section?`,
  actions: personalDashboardActionsRoute.path,
  upcoming: personalDashboardUpcomingRoute.path,
  toDos: personalDashboardToDosRoute.path,
  toDoModal: personalDashboardToDoModalRoute.path,
  approvals: personalDashboardApprovalsRoute.path,
  activity: personalDashboardActivityRoute.path,
} as const;
